
export class AuthUtil {
    static SUITE_TOKEN = 'smartShareCloudToken';
    static AUTH_HEADER = 'Authorization';
    static AUTH_SCHEMA = 'Bearer';
    static AUTH_SET_AUTHORIZATION_HEADER = 'Set-Authorization';
    static AUTH_SUITE_TOKEN_PROPERTY = 'SuiteToken';
    static AUTH_SUITE_JWT_TOKEN = 'satelittiJwtToken';
    static AUTH_SUITE_JWT_TOKEN_REFRESH = 'satelittiRefreshToken';
    static AUTH_HEADER_ACCESSKEY = 'AccessKey';
    static AUTH_USER_SIGN = 'UserSign';
    static SUITE_LANGUAGE = 'ssLanguage';
}
